import React from "react";
import { Link } from "react-router";
import PropTypes from "prop-types";
import moment from "moment";
import util from "../util/util";
import LoadingIndicatorText from "../loading-indicator/loading-indicator-text";

export default function ReportsTable(props) {
  return (
    <div className="table-responsive">
      <table className="table table-striped table-bordered table-hover">
        <colgroup>
          <col style={{ width: `1%` }}></col>
          <col style={{ width: `12%` }}></col>
          <col style={{ width: `6%` }}></col>
          <col style={{ width: `25%` }}></col>
          <col style={{ width: `27%` }}></col>
          <col style={{ width: `27%` }}></col>
          <col style={{ width: `2%` }}></col>
        </colgroup>
        <thead>
          <tr>
            <th>#</th>
            <th>Date</th>
            <th>Time</th>
            <th>Pod</th>
            <th>Shown After</th>
            <th>Shown Before</th>
            <th>Impressions</th>
          </tr>
        </thead>
        <tbody>{renderReportRows(props.reports)}</tbody>
      </table>
    </div>
  );

  // three options for display (loading, no results, results);
  function renderReportRows(reports = false) {
    if (reports.length === 0) {
      return (
        <tr>
          <td colSpan="6">
            <LoadingIndicatorText />
          </td>
        </tr>
      );
    } else if (reports === false) {
      return (
        <tr>
          <td>
            <strong>0</strong>
          </td>
          <td colSpan="5">{util.zeroReportsMessage}</td>
        </tr>
      );
    } else {
      return reports.map((report, index) => {
        return index < util.reportsResultsPerPage ? (
          <tr key={index}>
            <td>
              <strong>
                {util.returnLineNumber(
                  props.currentPage,
                  util.reportsResultsPerPage,
                  index
                )}
              </strong>
            </td>
            <td>{moment(report.airtime).format(util.dateFormatHumanLong)}</td>
            <td>{moment(report.airtime).format(`HH:mm`)}</td>
            <td>
              <Link to={util.returnPodDetailUrl(report.pod_id)}>
                {report.pod_name}
              </Link>
            </td>
            <td>
              {report.meta.showed_after ? report.meta.showed_after.title : null}
            </td>
            <td>
              {report.meta.showed_before
                ? report.meta.showed_before.title
                : null}
            </td>
            <td>{report.meta.total_count}</td>
          </tr>
        ) : null;
      });
    }
  }
}

ReportsTable.propTypes = {
  currentPage: PropTypes.number, // used to calc the # in the TABLE;
  reports: PropTypes.oneOfType([
    // pod data to display;
    PropTypes.array,
    PropTypes.bool
  ]),
  queryString: PropTypes.string // query string to add to sort links;
};
